var _path, _circle, _circle2, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgConsultation24(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    fillRule: "evenodd",
    clipRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 17c0 7.732 6.268 14 14 14s14-6.268 14-14M3 17V9a4 4 0 0 1 4-4M27 5a4 4 0 0 1 4 4v8M26.75 3a.25.25 0 0 1 .25.25v3.5a.25.25 0 0 1-.25.25l-1.725-.001L25 7a2 2 0 0 1-1.995-1.85L23 5a2 2 0 0 1 2-2h1.75zM7.25 3H9a2 2 0 1 1 0 4H7.25A.25.25 0 0 1 7 6.75v-3.5A.25.25 0 0 1 7.25 3z",
    stroke: "#FFF",
    strokeWidth: 2,
    fill: "none"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    stroke: "#FFF",
    strokeWidth: 2,
    fill: "none",
    cx: 49,
    cy: 55,
    r: 6
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    fill: "#FFF",
    cx: 49,
    cy: 55,
    r: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50.795 22h-9.083v-1.55l4.5-4.907c.65-.724 1.112-1.328 1.387-1.814.275-.485.413-.972.413-1.46 0-.644-.181-1.164-.543-1.56-.362-.395-.849-.593-1.461-.593-.73 0-1.296.222-1.698.668-.402.445-.603 1.054-.603 1.827h-2.254c0-.822.187-1.563.56-2.222.375-.658.91-1.17 1.606-1.535.696-.365 1.498-.547 2.407-.547 1.312 0 2.346.329 3.104.988.757.658 1.136 1.57 1.136 2.732 0 .674-.19 1.38-.57 2.12-.38.739-1.004 1.578-1.87 2.519L44.523 20.2h6.272V22zm9.342-4.815h1.68v1.81h-1.68V22h-2.254v-3.006h-5.836l-.065-1.373 5.827-9.129h2.328v8.693zm-5.789 0h3.535v-5.64l-.167.296-3.368 5.344z",
    fill: "#FFF",
    fillRule: "nonzero"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M49 49v-8M49 41a8 8 0 1 0-16 0M17 46a8 8 0 0 0 8 8h0a8 8 0 0 0 8-8M17 46V31M33 46v-5",
    stroke: "#FFF",
    strokeWidth: 2,
    fill: "none"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConsultation24);
export default __webpack_public_path__ + "static/media/consultation_24.b207f4d4722b4a73f54c7f38eb705a16.svg";
export { ForwardRef as ReactComponent };